import type { UsersListItem } from "./userlist-tooltip";

export interface NodeInteraction {
  user_type?: string | null;
  applicant?: {
    id: string;
    first_name?: string | null;
    last_name?: string | null;
  } | null;
}

// Maps every known backend user_type to its display label. Several values may
// resolve to the same label, so changes in the backend naming stay covered.
const USER_TYPE_DESCRIPTIONS: Record<string, string> = {
  holder: "Titular",
  processor: "Tramitador",
  executor: "Tramitador",
  analyst: "Analista",
  applicant: "Solicitante",
  facilitator: "Facilitador",
  representative: "Representante",
  institution: "Institución",
};

const DEFAULT_DESCRIPTION = "Otro";

export const mapInteractionsToUsersList = (
  interactions: NodeInteraction[] = [],
): UsersListItem[] => {
  const byUser = new Map<string, UsersListItem>();

  for (const { applicant, user_type } of interactions) {
    if (!applicant || byUser.has(applicant.id)) continue;
    const description =
      (user_type && USER_TYPE_DESCRIPTIONS[user_type]) ?? DEFAULT_DESCRIPTION;
    byUser.set(applicant.id, {
      id: applicant.id,
      title:
        `${applicant.first_name ?? ""} ${applicant.last_name ?? ""}`.trim() ||
        "Usuario desconocido",
      description: description,
      icon: { name: "user", type: "fas" },
    });
  }

  return [...byUser.values()];
};
